import { FC, useState } from 'react';
import { Dialog, DialogTitle, DialogContent, DialogActions } from '@mui/material';
import { useTranslation } from 'react-i18next';
import UtmsButton from '@shared/components/ui/UtmsButton';
import JiraIssueSelector from './JiraIssueSelector';
import { JiraIssue } from '../types';

interface DefectJiraIssueLinkDialogProps {
    open: boolean;
    onClose: () => void;
    onSave: (issue: JiraIssue) => void;
}

const DefectJiraIssueLinkDialog: FC<DefectJiraIssueLinkDialogProps> = ({ open, onClose, onSave }) => {
    const { t } = useTranslation();
    const [selectedIssue, setSelectedIssue] = useState<JiraIssue | null>(null);

    const handleSave = () => {
        if (selectedIssue) {
            onSave(selectedIssue);
            setSelectedIssue(null);
            onClose();
        }
    };

    const handleClose = () => {
        setSelectedIssue(null);
        onClose();
    };

    return (
        <Dialog open={open} onClose={handleClose} maxWidth="sm" fullWidth>
            <DialogTitle sx={{ fontSize: 16, fontWeight: 700 }}>{t('link_jira_issue')}</DialogTitle>
            <DialogContent sx={{ overflow: 'visible', pt: 2 }}>
                <JiraIssueSelector value={selectedIssue} onChange={setSelectedIssue} />
            </DialogContent>
            <DialogActions>
                <UtmsButton onClick={handleSave} disabled={!selectedIssue}>
                    {t('save')}
                </UtmsButton>
                <UtmsButton color="secondary" onClick={handleClose}>
                    {t('cancel')}
                </UtmsButton>
            </DialogActions>
        </Dialog>
    );
};

export default DefectJiraIssueLinkDialog;
